//@ts-ignore
/* eslint-disable */
import React from 'react';
import { useStore } from '../store/store';


export const useProgress = (routeGroups) => {
    const currentPage = useStore((state) => state.currentPage);
    const allRoutes = routeGroups.flat();

    const totalSteps = allRoutes.length;
  
    const completedGroups = routeGroups.map((group) => 
      group.every((route) => allRoutes.indexOf(currentPage) >= allRoutes.indexOf(route))
    );
  
    const currentStepIndex = allRoutes.findIndex((route) => route === currentPage);
    const progress = ((currentStepIndex + 1) / totalSteps) * 100;
  
    return { progress, completedGroups };
  };